var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#1A181E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4711 8.47157C16.7314 8.21122 16.7314 7.78911 16.4711 7.52876C16.2107 7.26841 15.7886 7.26841 15.5283 7.52876L11.9997 11.0574L8.47108 7.52876C8.21073 7.26841 7.78862 7.26841 7.52827 7.52876C7.26792 7.78911 7.26792 8.21122 7.52827 8.47157L11.0569 12.0002L7.52827 15.5288C7.26792 15.7891 7.26792 16.2112 7.52827 16.4716C7.78862 16.7319 8.21073 16.7319 8.47108 16.4716L11.9997 12.943L15.5283 16.4716C15.7886 16.7319 16.2107 16.7319 16.4711 16.4716C16.7314 16.2112 16.7314 15.7891 16.4711 15.5288L12.9425 12.0002L16.4711 8.47157Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircular);
export default __webpack_public_path__ + "static/media/cross-circular.3bb358c15ecc467cc3a9930688fae985.svg";
export { ForwardRef as ReactComponent };